var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { StudyType } from "healthex-common/study.dtos";
import { willNeverHappen } from "healthex-common/utils";
import { computed, observable } from "mobx";
import { getStudyStatusDescription } from "./StudyStatusHelpers";
export class HXStudyDetailsViewModelProps {
    constructor(study, container) {
        this.study = study;
        this.container = container;
    }
}
export class HXStudyDetailsViewModel {
    constructor(props) {
        const { study } = props;
        this.study = study;
    }
    get studyTypeDescription() {
        switch (this.study.studyType) {
            case StudyType.INTERVENTIONAL: {
                if (!this.study.clinicalTrialPhase)
                    return null;
                return `Clinical Trial, ${this.study.clinicalTrialPhase}`;
            }
            case StudyType.REGISTRY:
                return `Patient Registry`;
            case StudyType.OTHER:
                return `Other Observational Study`;
        }
        return willNeverHappen(this.study.studyType);
    }
    get studyStatusDescription() {
        return getStudyStatusDescription(this.study);
    }
}
__decorate([
    observable
], HXStudyDetailsViewModel.prototype, "study", void 0);
__decorate([
    computed
], HXStudyDetailsViewModel.prototype, "studyTypeDescription", null);
__decorate([
    computed
], HXStudyDetailsViewModel.prototype, "studyStatusDescription", null);
